<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      tableTitle="Accessorials"
      :fields="fields"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    />
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  export default {
    name: 'AccessorialSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    computed: {
      fields () {
        return [
          { header: 'Description', prop: 'description' },
          { header: 'Owner', prop: ({owner}) => (owner && owner.name) || '' },
          { header: 'Pre Carriage Location', prop: ({preCarriageLocation}) => preCarriageLocation ? (preCarriageLocation.name + (preCarriageLocation.subdivision ? ', ' + preCarriageLocation.subdivision : '') + (preCarriageLocation.country ? (', ' + preCarriageLocation.country.code) : '')) : '' },
          { header: 'Pre Carriage Country', prop: ({preCarriageCountry}) => (preCarriageCountry && preCarriageCountry.code) || '' },
          { header: 'Origin Location', prop: ({originLocation}) => originLocation ? (originLocation.name + (originLocation.subdivision ? ', ' + originLocation.subdivision : '') + (originLocation.country ? (', ' + originLocation.country.code) : '')) : '' },
          { header: 'Origin Country', prop: ({originCountry}) => (originCountry && originCountry.code) || '' },
          { header: 'Destination Location', prop: ({destinationLocation}) => destinationLocation ? (destinationLocation.name + (destinationLocation.subdivision ? ', ' + destinationLocation.subdivision : '') + (destinationLocation.country ? (', ' + destinationLocation.country.code) : '')) : '' },
          { header: 'Destination Country', prop: ({destinationCountry}) => (destinationCountry && destinationCountry.code) || '' },
          { header: 'On Carriage Location', prop: ({onCarriageLocation}) => onCarriageLocation ? (onCarriageLocation.name + (onCarriageLocation.subdivision ? ', ' + onCarriageLocation.subdivision : '') + (onCarriageLocation.country ? (', ' + onCarriageLocation.country.code) : '')) : '' },
          { header: 'On Carriage Country', prop: ({onCarriageCountry}) => (onCarriageCountry && onCarriageCountry.code) || '' },
          { header: 'Mode', prop: ({mode}) => (mode && mode.name) || '' },
          { header: 'Container Type', prop: ({containerType}) => (containerType && containerType.name) || '' },
          { header: 'Service', prop: ({serviceClass}) => serviceClass ? serviceClass.name : '' },
          { header: 'Rate', prop: ({rate, rateCurrency}) => rate + ' ' + ((rateCurrency && rateCurrency.code) || '') },
          { header: 'Rates Per', prop: ({ratesPer}) => (ratesPer && ratesPer.name) || '' }
        ]
      }
    },
    data () {
      return {
        loading: false,
        tableData: [],
        entityName: 'accessorial',
        editEntityScreen: 'Admin - Edit/View Accessorial',
        shouldSearchForExactMatch: true,
        orderBy: 'description ASCENDING, originLocation ASCENDING'
      }
    }
  }
</script>

<style scoped>
  .input-group input {
    border-radius: 30px 0 0 30px;
  }
  .input-group .input-group-addon {
    border-radius: 0 30px 30px 0;
  }
  .center-children-sm > * {
    border-radius: 0;
  }
  @media (max-width: 768px) {
    .center-children-sm > * {
      width:33%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/Accessorial/AccessorialSearchResults.vue